import React, { useState } from 'react';

import { Accordion, useNotification } from '@sopranodesign/pulse-components';
import { useRows, useQueryClient } from '@sopranodesign/pulse-hooks';

import EndpointDetails from './EndpointDetails';
import { useIntegrations, useRequest } from '../../hooks/index';
import { createEndpoint } from '../../api/index';

const CreateEndpoint = () => {
  const { showSuccess } = useNotification();
  const { viewEndpoints: integration } = useIntegrations();

  const queryClient = useQueryClient();

  const [resetFlag, setResetFlag] = useState(false);

  const { setRows, ...parameters } = useRows([]);
  let request = useRequest();

  request = { ...request, isSoap: integration.is_soap };

  const handleCreateEndpoint = async params => {
    await createEndpoint(integration.id, params);

    showSuccess(`Successfully created new endpoint for ${integration.name}`);
    setRows([]);
    setResetFlag(!resetFlag);
    request.resetRequest();
    queryClient.invalidateQueries('integrations');
  };

  return (
    <Accordion
      aria-label={`create-endpoint-chevron`}
      header={'Add New Endpoint'}>
      <EndpointDetails
        handleSubmit={handleCreateEndpoint}
        parameters={parameters}
        request={request}
        resetName={resetFlag}
      />
    </Accordion>
  );
};

export default CreateEndpoint;
